import { Menu } from "../models/menu.model";

export const MENU: Array<Menu> = [
  {
    icon: 'dashboard',
    route: '/dashboard',
    title: 'Dashboard',
  },
  {
    'icon': 'description',
    'title': 'Certificados',
    route: 'certificates',
  },
  {
    icon: 'article',
    title: 'Clientes',
    route: 'companies',
    rolesCanAccess: ['admin', 'sudo'],
  },
  {
    icon: 'article',
    title: 'Estandares',
    route: 'standards',
    rolesCanAccess: ['admin', 'sudo'],
  },
  {
    icon: 'precision_manufacturing',
    title: 'Equipos',
    route: 'equipments',
    rolesCanAccess: ['admin', 'sudo'],
  },
  {
    icon: 'settings',
    title: 'Tipos de Maquinaria',
    route: 'machine-types',
    rolesCanAccess: ['admin', 'sudo'],
  },
  {
    icon: 'military_tech',
    title: 'Niveles',
    route: 'levels',
    rolesCanAccess: ['admin', 'sudo'],
  },
  {
    icon: 'quiz',
    title: 'Exámenes',
    route: 'exams',
    rolesCanAccess: ['admin', 'sudo'],
  },
  {
    icon: 'group',
    title: 'Usuarios',
    route: 'users',
    onlyProfiles: ['sudo'],
  },
  {
    icon: 'key',
    title: 'Tokens',
    route: 'tokens',
    onlyProfiles: ['sudo'],
  },
];